import { useEffect } from "react";
import { getConsent, CONSENT_KEY } from "@/lib/consent";

/**
 * Carga scripts de GA4 y GTM sólo si están definidos los env vars
 * VITE_GA4_ID y VITE_GTM_ID, y sólo cuando el consentimiento de
 * analytics esté concedido (Google Consent Mode v2).
 */
export function AnalyticsScripts() {
  useEffect(() => {
    const ga4 = import.meta.env.VITE_GA4_ID as string | undefined;
    const gtm = import.meta.env.VITE_GTM_ID as string | undefined;
    if (!ga4 && !gtm) return;

    function ensureGtag() {
      window.dataLayer = window.dataLayer || [];
      window.gtag =
        window.gtag ||
        function gtag() {
          window.dataLayer!.push(arguments);
        };
    }

    function isAnalyticsGranted() {
      return getConsent()?.analytics === "granted";
    }

    function initGa4() {
      if (!ga4 || !isAnalyticsGranted()) return;
      ensureGtag();
      window.gtag!("js", new Date());
      window.gtag!("config", ga4);
    }

    function initGtm() {
      if (!gtm || !isAnalyticsGranted()) return;
      if (document.getElementById("gtm-script")) return;
      const s = document.createElement("script");
      s.id = "gtm-script";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtm.js?id=${gtm}`;
      document.head.appendChild(s);
      ensureGtag();
      window.dataLayer!.push({
        "gtm.start": Date.now(),
        event: "gtm.js",
      });
    }

    // Cargar el script externo de GA4 inmediatamente; con Consent Mode
    // default denied no envía hits hasta que el usuario conceda consentimiento.
    if (ga4 && !document.getElementById("ga4-script")) {
      const s = document.createElement("script");
      s.id = "ga4-script";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4}`;
      document.head.appendChild(s);
    }

    initGa4();
    initGtm();

    function onConsentChange() {
      initGa4();
      initGtm();
    }

    window.addEventListener("mc-consent-updated", onConsentChange);
    window.addEventListener("storage", (e) => {
      if (e.key === CONSENT_KEY) onConsentChange();
    });

    return () => {
      window.removeEventListener("mc-consent-updated", onConsentChange);
      window.removeEventListener("storage", onConsentChange);
    };
  }, []);
  return null;
}
